/**
 * insuranceLevel1.js — PROD-581 (insurance level 1, Alex 2026-10-05 V-1..V-9). The switch for the
 * "My insurance" screen (/profile/insurance/benefits) and its "See my benefits" link on
 * Profile -> Insurance.
 *
 * ★ ON. Alex approved the English of the 22 myInsurance.* keys on 2026-10-11 20:2x PDT ("581: die
 *   Texte sind ok"); Dr. Rami approved their Spanish at s99g (2026-10-11), and all 22 are in es.json
 *   (none in PENDING_ES_WITHHELD). Every other UI language has no myInsurance.* text yet, so there
 *   hasText() keeps the link undrawn and the page sends a direct visit to Profile -> Insurance.
 *   Not in this switch: the agent's my_insurance coverage answers (not built).
 *   Gate: scripts/check-insurance-level1.mjs IL-581d (on) and IL-581e (the screen rendered in es).
 */
export const MY_INSURANCE_SCREEN = true

export const MY_INSURANCE_PATH = '/profile/insurance/benefits'
